import type { ExcelColumnMapping } from './types';

export const BANG_KE_HOA_DON_MUA_HANG_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Đơn vị',
    width: 12,
    resolver: row => row?.unit_id ?? ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => row?.ngay_ct3
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row?.so_ct3 ?? ''
  },
  {
    header: 'Ngày nhập',
    width: 16,
    resolver: row => row?.ngay_ct
  },
  {
    header: 'Số c/từ nhập',
    width: 18,
    resolver: row => row?.so_ct ?? ''
  },
  {
    header: 'Ngày hóa đơn',
    width: 16,
    resolver: row => row?.ngay_ct0
  },
  {
    header: 'Số hóa đơn',
    width: 18,
    resolver: row => row?.so_ct0 ?? ''
  },
  {
    header: 'Mã NCC',
    width: 12,
    resolver: row => row?.ma_kh ?? ''
  },
  {
    header: 'Tên NCC',
    width: 28,
    resolver: row => row?.ten_kh ?? ''
  },
  {
    header: 'Diễn giải',
    width: 30,
    resolver: row => row?.dien_giai ?? ''
  },
  {
    header: 'Mã vật tư',
    width: 16,
    resolver: row => row?.ma_vt ?? ''
  },
  {
    header: 'Tên vật tư',
    width: 28,
    resolver: row => row?.ten_vt ?? ''
  },
  {
    header: 'ĐVT',
    width: 10,
    resolver: row => row?.dvt ?? ''
  },
  {
    header: 'Số lượng',
    width: 14,
    resolver: row => Number(row?.sl_nhap ?? '')
  },
  {
    header: 'Giá',
    width: 16,
    resolver: row => Number(row?.gia ?? '')
  },
  {
    header: 'Tiền',
    width: 16,
    resolver: row => Number(row?.tien0 ?? '')
  },
  {
    header: 'Chiết khấu',
    width: 16,
    resolver: row => Number(row?.ck ?? '')
  },
  {
    header: 'Tiền nhập',
    width: 16,
    resolver: row => Number(row?.tien_nhap ?? '')
  },
  {
    header: 'Thuế',
    width: 14,
    resolver: row => Number(row?.thue ?? '')
  },
  {
    header: 'Mã tính chất',
    width: 16,
    resolver: row => row?.ma_tc_thue ?? ''
  },
  {
    header: 'Thuế suất',
    width: 16,
    resolver: row => row?.thue_suat ?? ''
  },
  {
    header: 'Chi phí',
    width: 16,
    resolver: row => Number(row?.cp ?? '')
  },
  {
    header: 'Tổng thanh toán',
    width: 18,
    resolver: row => Number(row?.tong_tt ?? '')
  },
  {
    header: 'Mã kho',
    width: 12,
    resolver: row => row?.ma_kho ?? ''
  },
  {
    header: 'TK vật tư',
    width: 12,
    resolver: row => row?.tk_vt ?? ''
  },
  {
    header: 'TK công nợ',
    width: 14,
    resolver: row => row?.tk_du ?? ''
  },
  {
    header: 'Bộ phận',
    width: 16,
    resolver: row => row?.ma_bp ?? ''
  },
  {
    header: 'Vụ việc',
    width: 16,
    resolver: row => row?.ma_vv ?? ''
  },
  {
    header: 'Hợp đồng',
    width: 16,
    resolver: row => row?.ma_hd ?? ''
  },
  {
    header: 'Đợt thanh toán',
    width: 18,
    resolver: row => row?.ma_dtt ?? ''
  },
  {
    header: 'Khế ước',
    width: 16,
    resolver: row => row?.ma_ku ?? ''
  },
  {
    header: 'Phí',
    width: 12,
    resolver: row => row?.ma_phi ?? ''
  },
  {
    header: 'Sản phẩm',
    width: 16,
    resolver: row => row?.ma_sp ?? ''
  },
  {
    header: 'Lệnh sản xuất',
    width: 18,
    resolver: row => row?.ma_lsx ?? ''
  },
  {
    header: 'C/p không h/lệ',
    width: 18,
    resolver: row => row?.ma_cp0 ?? ''
  },
  {
    header: 'Mã c/từ',
    width: 16,
    resolver: row => row?.ma_ct ?? ''
  }
];
